import { contactUs } from 'api';
import { useMutation } from 'react-query';

function useContactUsMutation() {
  return useMutation({
    mutationKey: ['contact'],
    mutationFn: (data) => contactUs(data),
  });
}

export default useContactUsMutation;
